/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Enum for routes that should be displayed in the drawer navigation.
 * Add new routes here when they should appear in the drawer menu.
 */
export enum DrawerNavigationRoute {
	dashboard = "Dashboard",
	userManagement = "UserManagement",
	upload = "Upload",
}

